import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useQuery from 'hooks/useQuery';
import Input from 'v3/components/Input';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Spinner from 'react-bootstrap/Spinner';
import { CNPJ_MASK } from 'v3/utils/masks';

const LOADER_COLOR = '#ffffff';
const HAS_NUMBER_REGEX = /\d/;

export default function Filter({ loading = false }) {
  const navigate = useNavigate();
  const query = useQuery();

  const [filter, setFilter] = useState({ q: '' });

  const debounceRef = useRef(null);
  const initRef = useRef(true);

  useEffect(() => {
    if (query.has('q')) {
      setFilter((prev) => ({ ...prev, q: query.get('q') || '' }));
    }
    initRef.current = false;
  }, []);

  function updateQueryString(value) {
    const trimmed = value.trim();

    if (!trimmed) {
      query.delete('q');
    } else {
      query.set('q', trimmed);
    }

    navigate({ search: query.toString() });
  }

  function applyFilterImmediate() {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }

    updateQueryString(filter.q);
  }

  useEffect(() => {
    if (initRef.current) return;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      updateQueryString(filter.q);
      debounceRef.current = null;
    }, 800);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [filter.q]);

  return (
    <Row
      className="mb-4 d-flex align-items-end business-group-filter-row"
      style={{ width: '110%', marginLeft: 0, marginRight: 0 }}
    >
      <Col xs={12} md={10}>
        <Text className="mb-4 text-white">
          Buscar por nome ou CNPJ
        </Text>

        <Input
          className="filter-white-input"
          placeholder="Ex.: ACME ou 12.345.678/0001-90"
          value={filter.q ?? ''}
          masked={HAS_NUMBER_REGEX.test(filter.q)}
          guide={false}
          mask={CNPJ_MASK}
          onChange={(eOrValue) => {
            const value =
              typeof eOrValue === 'string'
                ? eOrValue
                : eOrValue?.target?.value ??
                  eOrValue?.value ??
                  '';

            setFilter((prev) => ({ ...prev, q: value.toUpperCase() }));
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              applyFilterImmediate();
            }
          }}
          disabled={loading}
        />
      </Col>

      <Col xs={12} md={2}>
        <Button
          variant="success"
          onClick={applyFilterImmediate}
          disabled={loading}
          style={{
            minHeight: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {loading ? (
            <Spinner
              animation="border"
              role="status"
              size="sm"
              style={{ color: LOADER_COLOR }}
            />
          ) : (
            <Text type="regular" weight={500}>
              Filtrar
            </Text>
          )}
        </Button>
      </Col>
    </Row>
  );
}
